var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.PanelObj = new Class({
    Implements: [Options, Events],
    panel: null,
    product: null,
    product_type: null,
    popup: null,
    product_meta_info: {},
    bound_methods: {},
    options: {
        entry_id: null,
        class_name: 'panel',
        panels_container: null,
        append_to_container: true,
        update_url_event_string: 'update_url_event'
    },
    initialize: function (dom_element, op) {
        if(op && op.popup) {
            this.set_popup(op.popup);
            delete op.popup;
        }
        if (!dom_element) {
            // We initialized without an item, this means we are creating a panel
            this.setOptions(op);
            this.draw(op);
        } else {
            // We initialized with an item, check for if a panel was initialized here
            var current_panel = dom_element.retrieve('panel_obj');
            if (current_panel) {
                return current_panel;
            }
            // We made it here, this means no panel was inited on this item
            this.setOptions(op);
            this.set_panel(dom_element);

        }
        this.bound_methods.on_url_state_change = this.on_url_state_change.bind(this);
        this.bound_methods.on_mouseup = this.on_mouseup.bind(this);
        this.bound_methods.on_mousedown = this.on_mousedown.bind(this);
        // Store this into the panel for later retreival. 
        if (this.panel) {
            this.panel.store('panel_obj', this);
            if (!this.panel.hasClass('thumb')) {
                var url_mngr = OCS.WxBriefing.Functions.get_url_manager();
                url_mngr.addEvent(url_mngr.options.url_state_change_event, this.bound_methods.on_url_state_change);
            }

            var state = this.get_panel_url_state();
            /* istanbul ignore if */
            if (state.entry_id) {
                this.set_product_meta_info(state);
                this.start_spin();
                var pr = new OCS.WxBriefing.Classes.ProductRequest({entry_id: state.entry_id});
                pr.then(this.product_fetched.bind(this));
                pr.start();
            } else {
                this.empty_panel(true);
            }
        }
    },
    draw: function (ops) {
        if (ops && ops.panel_id) {
            var panel_el = new Element('div', {"id": ops.panel_id, "class": this.options.class_name});
            var panel_contents = Elements.from(OCS.WxBriefing.Functions.get_template_manager().get_html('panel_contents'));
            panel_contents.inject(panel_el);
            this.set_panel(panel_el);
            this.apply_panel_class();
            this.append_to_container();
        }

    },
    append_to_container: function () {
        if (this.options.append_to_container && this.panel && this.options.panels_container) {
            this.panel.inject(this.options.panels_container);
            this.options.append_to_container = false;
        }
    },
    apply_panel_class: function () {
        this.panel.addClass(this.get_panel_id());
    },
    get_url_panel_id: function () {
        return this.get_panel_id().replace('panel_', 'p');
    },
    get_panel_id: function () {
        var id = this.panel.getProperty('id');
        if (!id) {
            id = "";
        }
        return id;
    },
    set_panel_id: function (id) {
        var panel_state = this.get_panel_url_state();
        var old_id = this.get_panel_id();
        this.panel.setProperty('id', id);
        if (old_id && old_id !== id) {
            var new_state = {};
            new_state[this.get_url_panel_id()] = panel_state;
            OCS.WxBriefing.Functions.get_url_manager().update_url_state(new_state, 0);
        }
        this.resize();
    },
    get_panel_url_state: function () {
        var current_state = OCS.Utilities.clone_object(OCS.WxBriefing.Functions.get_url_manager().current_url_state);
        var panel_id = this.get_url_panel_id();
        var state = current_state[panel_id];
        if (state) {
            if (OCS.Utilities.is_string(state)) {
                state = {entry_id: state};
            }
            return state;
        }
        return {};
    },
    set_panel: function (panel) {
        this.panel = panel;
    },
    get_panel: function () {
        return this.panel;
    },
    get_panel_contents: function () {
        if (!this.panel_contents) {
            this.panel_contents = new Element('div', {"class": "map noHighlight panel_contents"}).inject(this.panel);
        }
        return this.panel_contents;
    },
    get_panel_contents_entry_id: function () {
        return this.get_panel_contents().getProperty("data-entry_id");
    },
    get_product: function () {
        return this.product;
    },
    get_product_type: function () {
        return this.product_type;
    },
    add_product_to_panel: function (product) {
        if (this.product) {
            this.resize();
        }
        var requested_entry_id = product.get_entry_id();

        // There is a difference or the we have not loaded a product
        if (!this.product || (product && this.product.get_entry_id() !== requested_entry_id)) {
            if (!this.product && product.retrieved) {
                this.product_fetched(product);
                return;
            }

            // Empty and load the new product
            this.empty_panel();
            if (requested_entry_id) {
                if (product.retrieved) {
                    this.product_fetched(product);
                } else {
                    this.start_spin();
                    var pr = new OCS.WxBriefing.Classes.ProductRequest({entry_id: requested_entry_id});
                    pr.then(this.product_fetched.bind(this));
                    pr.start();
                }
            }
        } else {
            // Set the product info to that of the incoming product info
            this.product = product;
        }
        // We have a product and the IDs match send the rest of the product info


    },
    product_fetched: function (product) {
        if (!OCS.Utilities.is_empty(product)) {
            this.get_panel_contents().setProperty("data-entry_id", product.get_entry_id());
            this.panel.removeClass('empty');
            this.stop_spin();
            switch (product.get_product_type()) {
                case OCS.Constants.EMBEDDABLE_URL:
                    this.load_embeddable_url(product);
                    break;
                case OCS.Constants.EMBEDDABLE_TEXT:
                    this.load_embeddable_text(product);
                    break;
                case OCS.Constants.EMBEDDABLE_IMAGE:
                    this.load_embeddable_image(product);
                    break;
                case OCS.Constants.DYNAMIC_MAP:
                    this.load_dynamic_map(product);
                    break;
                case OCS.Constants.EMBEDDABLE_PRODUCT:
                    this.load_embeddable_product(product);
                    break;
                case OCS.Constants.EMBEDDABLE_STATIC_URL:
                    this.load_embeddable_static_url(product);
                    break;
            }
            this.product = product;
            this.set_title(this.product.get_product_title());
            var pm = OCS.WxBriefing.Functions.get_product_manager();
            OCS.WxBriefing.Functions.get_ui().send_analytic_event({'category': 'Product', 'action': "Load", 'label': pm.get_product_ga_label(product.get_entry_id())});
        } else {
            this.empty_panel(true);
        }
    },
    resize: function () {
        if (this.product_type) {
            this.product_type.resize();
        }
    },
    load_embeddable_url: function (product) {
        this.product_type = new OCS.WxBriefing.Classes.EmbeddableUrl({
            container_selector: this.get_panel_id() + " .map",
            container: this.panel_contents,
            product_meta_info: this.product_meta_info
        });
        this.product_meta_info = {};
        this.product_type.set_product(product);
        this.product_type.render();
        this.init_panel_options_handlers();
    },
    load_embeddable_static_url: function (product) {
        this.product_type = new OCS.WxBriefing.Classes.EmbeddableStaticUrl({
            container_selector: this.get_panel_id() + " .map",
            container: this.panel_contents
        });
        this.product_type.set_product(product);
        this.product_type.render();
        this.init_panel_options_handlers();
    },
    load_embeddable_text: function (product) {
        this.product_type = new OCS.WxBriefing.Classes.EmbeddableText({
            container_selector: this.get_panel_id() + " .map",
            container: this.panel_contents
        });
        this.product_type.set_product(product);
        this.product_type.render();
        this.init_panel_options_handlers();
    },
    load_embeddable_product: function (product) {
        this.product_type = new OCS.WxBriefing.Classes.EmbeddableProduct({
            container_selector: this.get_panel_id() + " .map",
            product_meta_info: this.product_meta_info,
            container: this.panel_contents
        });
        this.product_meta_info = {};
        this.product_type.set_product(product);
        this.product_type.render();
        this.init_panel_options_handlers();
    },
    load_embeddable_image: function (product) {
        this.product_type = new OCS.WxBriefing.Classes.EmbeddableImage({
            container_selector: this.get_panel_id() + " .map",
            container: this.panel_contents,
            product_meta_info: this.product_meta_info
        });
        this.product_meta_info = {};
        this.product_type.set_product(product);
        this.product_type.render();
        this.init_panel_options_handlers();
    },
    get_dynamic_map_obj: function () {
        return OCS.WxBriefing.Classes.DynamicMap;
    },
    load_dynamic_map: function (product) {
        var map_obj = this.get_dynamic_map_obj();
        this.product_type = new map_obj({
            container_selector: this.get_panel_id() + " .map",
            container: this.panel_contents,
            product_meta_info: this.product_meta_info
        });
        this.product_meta_info = {};
        this.product_type.set_product(product);
        // Attach the popup to the product so it knows to tie into it.
        if (this.popup) {
            this.product_type.set_popup(this.popup);
        }
        this.product_type.render();
        this.init_panel_options_handlers();
    },
    init_panel_options_handlers: function () {
        this.panel.addEvent('mousedown', this.bound_methods.on_mousedown);
        this.panel.addEvent('mouseup', this.bound_methods.on_mouseup);
    },
    remove_panel_options_handlers: function () {
        this.panel.removeEvents();
    },
    openPanel: function (target, e) {
        // Replace with fx.slide
        $(target).siblings('.panel_options_container').addClass('active').velocity({right: '0px'});
    },
    closePanel: function (target, e) {
        // replace with fx.slide
        $(target).closest('.panel_options_container').velocity({right: '-226px'}).removeClass('active');
    },
    empty_panel: function (showEmptyPanelUI) {
        if (this.product_type) { // TODO: Verify this is emptying all the url related items attached to the panel
            OCS.WxBriefing.Functions.get_ui().send_analytic_event({'category': 'Product', 'action': "UnLoad", 'label': OCS.WxBriefing.Functions.get_product_manager().get_product_ga_label(this.product.get_entry_id())});
            this.product_type.destroy();
            this.product_type = null;
            this.product = null;
        }
        this.remove_panel_options_handlers();
        if (this.panel_contents) {
            this.panel_contents.setProperty("data-entry_id", null);
            this.panel_contents.removeEvents();
            this.panel_contents.empty();
        }
        this.set_title("");
        this.set_timestamp("");
        if (showEmptyPanelUI) {
            this.panel.addClass('empty');
        }
    },
    removeProduct: function () {
        if (confirm('Are you sure you want to remove the product from this panel?')) {
            var new_state = {};
            new_state[this.get_url_panel_id()] = null;
            OCS.WxBriefing.Functions.get_url_manager().update_url_state(new_state, 0);
        }
    },
    addToMyProducts: function (target, e) {
        target = (target instanceof jQuery) ? target : $(target);
        target.find('.loader16').addClass('spinner');
        var entry_id = this.get_panel_contents_entry_id();
        var pm = OCS.WxBriefing.Functions.get_product_manager();
        OCS.WxBriefing.Functions.get_ui().send_analytic_event({'category': 'Product', 'action': "MyProducts - Add", 'label': pm.get_product_ga_label(entry_id)});
        OCS.WxBriefing.Functions.get_ui_menu().get_myproducts_menu().add_to_my_products(entry_id);
    },
    set_product_meta_info: function (product_meta_info) {
        if (this.product_type) {
            this.product_type.set_product_meta_info(product_meta_info);
            this.product_meta_info = {};
        } else {
            this.product_meta_info = product_meta_info;
        }
    },
    get_product_meta_info: function() {
        if (this.product_type) {
            return this.product_type.get_product_meta_info();
        } else {
            return this.product_meta_info;
        }
    },
    start_spin: function () {
        this.panel.removeClass('empty').addClass('black').addClass('spinner').addClass('large');
    },
    stop_spin: function () {
        this.panel.removeClass('spinner');
    },
    set_title: function (title) {
        if (!this.popup) {
            var title_el = this.panel.getElement('.product_title');
            if (title_el) {
                title_el.set('html', title);
            }
        } else {
            this.popup.set_title(title);
        }
    },
    set_timestamp: function (timestamp) {
        if (!this.popup) {
            var timestamp_el = this.panel.getElement('div.title span.timestamp');
            if (timestamp_el) {
                timestamp_el.set('html', timestamp);
            }
        } else {
            this.popup.set_timestamp(timestamp);
        }
    },
    set_popup: function (popup) {
        if(this.panel) {
            this.panel.removeClass('empty');
        }
        this.popup = popup;
        if (this.product_type) {
            this.product_type.set_popup(popup);
        }
    },
    on_mousedown: function (event) {
        OCS.WxBriefing.Functions.get_url_manager().allow_url_changes = false;
    },
    on_mouseup: function (event) {
        OCS.WxBriefing.Functions.get_url_manager().allow_url_changes = true;
        var target = event.target;
        if (target.hasClass('sprite-panel-options-button')) {
            this.openPanel(target, event);
        } else if (target.hasClass('close-panel-options-container')) {
            this.closePanel(target, event);
        } else if (target.hasClass('remove-product')) {
            this.removeProduct(target, event);
        } else if (target.hasClass('fullscreen-product')) {
            if (this.product) {
                OCS.WxBriefing.Functions.get_ui().show_product_fullscreen(this.product, this.get_product_meta_info());
            }
        } else if (target.hasClass('add-to-my-products')) {
            this.addToMyProducts(target, event);
        }
    },
    on_url_state_change: function (new_state, old_state) {
        if (!this.popup) {
            var state = this.get_panel_url_state();
            if (!state.entry_id) {
                this.empty_panel(true);
            } else if (state.entry_id !== this.get_panel_contents_entry_id()) {
                this.empty_panel();
                this.set_product_meta_info(state);
                this.start_spin();
                var pr = new OCS.WxBriefing.Classes.ProductRequest({entry_id: state.entry_id});
                pr.then(this.product_fetched.bind(this));
                pr.start();
            }
            this.set_product_meta_info(state);
            if (this.product) {
                this.resize();
            }
        }
    },
    destroy: function () {
        if (this.panel) {
            var new_state = {};
            new_state[this.get_url_panel_id()] = null;
            OCS.WxBriefing.Functions.get_url_manager().update_url_state(new_state, 0);
            this.panel.store('panel_obj', null);
            this.panel.removeEvents();
            this.panel.destroy();
        }
    }
});